// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bridge-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M22 21.0004V3H18V21.0004H22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M2 20.9994V2.99902H6V20.9994H2Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 7.99927C8 7.99927 6 5.99927 6 5.99927V15.9993H18V5.99927C18 5.99927 16 7.99927 12 7.99927ZM12 7.99927V15.999M22 3V21.0004H18V3H22ZM2 2.99902V20.9994H6V2.99902H2Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bridge-1')
export default class Bridge1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bridge-1',
    }
  }
}
